import type { Theme } from '@mui/material/styles'

const MuiIconButton = (baseTheme: Theme) => ({
  styleOverrides: {
    root: {
      padding: baseTheme.spacing(0.25),
    },
  },
})

export default MuiIconButton
